import React from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import "./style.scss";

export default class RotateImgComp extends React.Component {
  _rotate = () => {
    const { crop_img, filename, rotation } = this.props;

    let arr = crop_img.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    let files = new File([u8arr], filename, { type: mime });

    let newRotation = rotation + 90;

    if (newRotation >= 360) {
      newRotation = 0;
    }

    this.props.rotates(newRotation, files);
  };

  _crop = () => {
    if (typeof this.cropper.getCroppedCanvas() === "undefined") {
      return;
    }

    this.props.croppers(this.cropper.getCroppedCanvas().toDataURL());
  };

  render() {
    const { org_img } = this.props;
    return (
      <div className="cropper_comp">
        <Cropper
          checkCrossOrigin={false}
          style={{ height: 300 }}
          aspectRatio={4 / 4}
          preview=".img-preview"
          guides={false}
          src={org_img}
          ref={cropper => {
            this.cropper = cropper;
          }}
        />

        <div className="button_crop">
          <button type="button" onClick={this._rotate}>
            <span>Rotate</span>
            <i className="fa fa-repeat" />
          </button>

          <button type="button" onClick={this._crop}>
            <span> Crop</span>
            <i className="fa fa-crop" />
          </button>
        </div>
      </div>
    );
  }
}
